<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2242_5193)">
<rect x="12.5" y="5.83167" width="6.96048" height="1" fill="currentColor"/>
<path d="M6 11.165H6.12C6.94843 11.165 7.62 11.8366 7.62 12.665V17.335C7.62 18.1635 6.94843 18.835 6.12 18.835H6V11.165Z" fill="currentColor"/>
<rect x="12.6201" y="14.5" width="9.34086" height="1" fill="currentColor"/>
<rect opacity="0.1" x="6" y="10.1649" width="26" height="9.67001" fill="currentColor"/>
<rect x="12.5" y="23.1682" width="6.96048" height="1" fill="currentColor"/>
</g>
<rect x="5.3" y="1.79829" width="27.4" height="26.4033" rx="1.2" stroke="currentColor" stroke-width="1.4"/>
<defs>
<clipPath id="clip0_2242_5193">
<rect x="6" y="2.49829" width="26" height="25.0033" rx="0.5" fill="white"/>
</clipPath>
</defs>
</svg>
